import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { type FC } from "react";

import { CustomBadge } from "./CustomBadge";

interface CustomBadgeButtonProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  children: React.ReactNode;
  onCheckedChange?: (checked: CheckboxPrimitive.CheckedState) => void;
}

const CustomBadgeButton: FC<CustomBadgeButtonProps> = ({
  checked,
  onCheckedChange,
  disabled,
  children,
  ...rest
}) => {
  return (
    <CheckboxPrimitive.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-checked={checked === "indeterminate" ? "mixed" : checked}
      className="cursor-pointer transition-opacity disabled:opacity-50 disabled:pointer-events-none"
      {...rest}
    >
      <CustomBadge variant={checked ? "black" : "default"}>
        {children}
      </CustomBadge>
    </CheckboxPrimitive.Root>
  );
};

export default CustomBadgeButton;
